<template>
  <b-badge :variant="newValue ? 'success' : 'danger'">{{newValue.toString().toUpperCase()}}</b-badge>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    newValue() {
      if (this.value === "false") {
        return false;
      }

      if (this.value === "true") {
        return true;
      }

      if (typeof this.value === "boolean") {
        return this.value;
      }

      return !!this.value;
    }
  }
};
</script>
